import React from "react";
import HomepageHero from "@/components/Homepage/Hero";
import WhatWeBuy from "@/components/Homepage/WhatWeBuy";
import Collateral from "@/components/Homepage/Collateral";
import TrustedByMany from "@/components/Common/TrustedByMany";
import FeaturedOn from "@/components/Common/FeaturedOn";
import AboutMB from "@/components/Common/AboutMB";
import FAQ from "@/components/Common/FAQ";
import HowItWorks from "@/components/Common/HowItWorks";
import FreeAppraisal from "@/components/Common/FreeAppraisal";
import Resources from "@/components/Homepage/Resources";
import { createClient } from "../../prismicio";
import { SliceZone } from "@prismicio/react";
import Metadata from "@/components/Metadata";
import Layout from "@/components/Layout";
import SchemaScript from "@/components/SchemaScript";
import Richtext from "@/components/Homepage/Richtext/Richtext";
import RolexWatches from "@/components/Homepage/RolexWatches";
import CtaWithVideo from "@/components/Homepage/CtaWithVideo";

export default function Home({ page, globals, blogs, ourProcessPageData }) {
  const pageData = page?.data;
  const commonComponents = globals?.data;

  const components = {
    faqs: FAQ,
  };

  const whatWeBuy = {
    title: pageData?.what_we_buy_title || "",
    data: pageData?.what_we_buy || [],
  };

  const collateral = {
    title: pageData?.collateral_title,
    subTitle: pageData?.collateral_subtitle || [],
    text: pageData?.collateral_description || [],
    viewMoreLink: pageData?.view_more_link || {},
    image: pageData?.collateral_image || {},
  };

  const rolexWatches = {
    title: pageData?.rolex_watches_title,
    subTitle: pageData?.rolex_watches_subtitle || [],
    text: pageData?.rolex_watches_description || [],
    buttonLabel: pageData?.rolex_watches_button_label || {},
    buttonLink: pageData?.view_more_link || {},
    image: pageData?.rolex_watches_image || {},
  };

  const ctaWithVideo = {
    title: pageData?.cta_with_video_title || [],
    description: pageData?.cta_with_video_description || [],
    videoLink: pageData?.cta_with_video_link,
  };

  const resources = {
    title: pageData?.resouces_title || "",
    data: blogs || [],
  };

  return (
    <Layout data={commonComponents}>
      <SchemaScript data={pageData?.schema_json} />
      <Metadata
        title={pageData?.metadata_title}
        description={pageData?.metadata_desc}
        image={pageData?.metadata_image.url}
        path="/"
      />
      <HomepageHero hero={pageData?.hero} page={"Homepage"} />
      <FeaturedOn data={commonComponents} />
      <WhatWeBuy data={whatWeBuy} />
      <Collateral data={collateral} page={"Homepage"} />
      <RolexWatches data={rolexWatches} />
      <CtaWithVideo data={ctaWithVideo} />
      <TrustedByMany data={commonComponents} page={"Homepage"} />
      <HowItWorks data={pageData} />
      <AboutMB data={commonComponents} page={"Homepage"} />
      {pageData?.rich_text_content?.length > 0 && (
        <Richtext data={pageData.rich_text_content} />
      )}
      <SliceZone slices={page?.data?.slices3} components={components} />
      <FreeAppraisal whiteBg={true} data={pageData} page={"Homepage"} />
      <Resources data={resources} />
      <div style={{ height: "40px" }}></div>
    </Layout>
  );
}

export async function getStaticProps({ previewData }) {
  const client = createClient({ previewData });

  const page = await client.getSingle("homepage");
  const globals = await client.getSingle("globals");
  const blogs = await client.getAllByType("blog_individual_page");
  const ourProcessPageData = await client.getSingle("our_process_page");

  return {
    props: {
      page,
      globals,
      blogs: blogs.slice(0, 3).map(({ uid, data }) => {
        const { title, image, excerpt } = data;
        return {
          uid,
          data: {
            title,
            image,
            excerpt,
          },
        };
      }),
      ourProcessPageData,
    },
  };
}
